import React, { useState } from 'react';
import { Grid, Typography, Box, Container, Tabs, Tab } from '@mui/material';
import './docsdetails.css';
import FeaturedCard from '../Cards/Featured/FeatureCard';
import RecentCard from '../Cards/Recent/RecentCard';
import AdditonalCard from '../Cards/Popular/AdditonalCard';
import { docsPosts, DOC_CATEGORIES } from '../../utils/docsData';

const DocsDetails = () => {
    const [category, setCategory] = useState('All');

    const filtered =
        category === 'All'
            ? docsPosts
            : docsPosts.filter((post) => post.category === category);

    const featured = filtered[0] || docsPosts[0];
    const recent = filtered.slice(1, 4);
    const additional = filtered.slice(4, 8).length
        ? filtered.slice(4, 8)
        : filtered.slice(0, 4);

    return (
        <Box className="blog-page">
            <Container maxWidth="lg">
                <Box sx={{ mb: 4 }}>
                    <Typography variant="overline" sx={{ color: '#2cbb5d', fontWeight: 'bold', letterSpacing: 2 }}>
                        Docs
                    </Typography>
                    <Typography variant="h3" sx={{ color: '#fff', fontWeight: 800, mb: 1 }}>
                        EvolveX Docs
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#a1a1aa', mb: 2 }}>
                        Notes, guides, and arcade algorithms — grouped by theme.
                    </Typography>
                    <Tabs
                        value={category}
                        onChange={(_, val) => setCategory(val)}
                        variant="scrollable"
                        scrollButtons="auto"
                        sx={{
                            '& .MuiTab-root': { color: '#a1a1aa', textTransform: 'none' },
                            '& .Mui-selected': { color: '#2cbb5d' },
                            '& .MuiTabs-indicator': { bgcolor: '#2cbb5d' },
                        }}
                    >
                        <Tab label="All" value="All" />
                        {DOC_CATEGORIES.map((cat) => (
                            <Tab key={cat} label={cat} value={cat} />
                        ))}
                    </Tabs>
                </Box>

                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        <FeaturedCard
                            title={featured.title}
                            author_id={featured.author}
                            comments={featured.numComments}
                            date={featured.datePublished}
                            description={featured.description}
                            id={featured.id}
                            category={featured.category}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <div className="posts-container">
                            <div className="recent-posts">
                                <Typography variant="h6" className="sidebar-heading">
                                    In this category
                                </Typography>
                                {recent.map((post) => (
                                    <RecentCard
                                        key={post.id}
                                        title={post.title}
                                        author_id={post.author}
                                        id={post.id}
                                    />
                                ))}
                            </div>

                            <div className="additional-posts">
                                {additional.map((post) => (
                                    <AdditonalCard
                                        key={post.id}
                                        title={post.title}
                                        author_id={post.author}
                                        comments={post.numComments}
                                        date={post.datePublished}
                                        description={post.description}
                                        id={post.id}
                                        category={post.category}
                                    />
                                ))}
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default DocsDetails;
